// import './format.css'
import { FaUser, FaShoppingCart, FaChartLine, FaCampground, FaWallet, FaChartBar, FaFreeCodeCamp, FaTicketAlt } from "react-icons/fa";
import { CgSpinner } from "react-icons/cg";
import { MdOutlineRequestPage } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { SiYourtraveldottv } from "react-icons/si";
import { getUserDashboard } from "services/dashboard";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AuthenticationContext from "Authentication/AuthenticationContext";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

export default function Management() {
  const { userInfo } = useContext(AuthenticationContext);
  const [manageValue, setManageValue] = useState({
    buyCount: 0,
    inventory: 0,
    ticketCount: 0,
    tourCount: 0,
  });

  const [tourId, setTourId] = useState(-1);

  useEffect(() => {
    let id = userInfo.id;
    //let id = 114;
    const getInfo = async () => {
      let data = await getUserDashboard(id).then((res) => res);
      setManageValue((prev) => {
        return { ...prev, buyCount: data.buyCount, inventory: data.inventory, ticketCount: data.ticketCount, tourCount: data.tourCount };
      });
    };
    getInfo();
  }, []);
  return (
    <div className="d-flex flex-nowrap ">
      <div className="col py-3 manager1">
        <div className="d-flex flex-wrap justify-content-center px-2">
          <div className="d-flex justify-content-between flex-column flex-md-row w-100">
            <div className="amar m-2 text-center bg-white ">
              <NavLink to="/customer-panel/transactions">
                <div className="d-flex border rounded-3">
                  <div className="rounded p-5" style={{ backgroundColor: "#2baa31" }}>
                    <FaWallet className=" text-white fs-50" />
                  </div>
                  <div className="p-4 mx-auto">
                    <h5 className="digits text-black-50">{addCommas(manageValue.inventory)}</h5>

                    <h6 className="text-black-50">موجودی کیف پول</h6>
                  </div>
                </div>
              </NavLink>{" "}
            </div>
            <div className="amar m-2 text-center bg-white">
              <NavLink to="/customer-panel/orders">
                <div className="d-flex border border rounded-3">
                  <div className="rounded p-5" style={{ backgroundColor: "#2b84aa" }}>
                    <SiYourtraveldottv className=" text-white fs-50 " />
                  </div>
                  <div className="p-4 mx-auto">
                    <h5 className="digits text-black-50">{manageValue.tourCount}</h5>
                    <h6 className="text-black-50">تعداد سفر های شما</h6>
                  </div>
                </div>
              </NavLink>{" "}
            </div>
          </div>
          <div className="d-flex justify-content-between flex-column flex-md-row w-100">
            <div className="amar m-2 text-center bg-white ">
              <NavLink to="/customer-panel/orders">
                <div className="d-flex border rounded-3">
                  <div className="rounded p-5" style={{ backgroundColor: " rgb(228, 58, 58)" }}>
                    <FaShoppingCart className=" text-white fs-50" />
                  </div>
                  <div className="p-4 mx-auto">
                    <h5 className="digits text-black-50">{manageValue.buyCount}</h5>
                    <h6 className="text-black-50">تعداد خرید های شما</h6>
                  </div>
                </div>
              </NavLink>
            </div>
            <div className="amar m-2 text-center bg-white">
              <NavLink to="/customer-panel/orders">
                <div className="d-flex border rounded-3">
                  <div className="rounded  p-5" style={{ backgroundColor: "rgb(146, 82, 120)" }}>
                    <FaTicketAlt className=" text-white fs-50 " />
                  </div>
                  <div className="p-4 mx-auto">
                    <h5 className="digits text-black-50">{manageValue.ticketCount}</h5>
                    <h6 className="text-black-50">تعداد بلیط های شما</h6>
                  </div>
                </div>
              </NavLink>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
